import { Injectable, Inject } from 'ng-metadata/core';

@Injectable()
export class PasswordStrengthService {
    constructor() {}

    public getPasswordStrength(password) {
        if (!password) {
            password = '';
        }

        let strengthScore = 1;
        let length = password.length;
        let upperCase = this.passwordUpperCase(password);
        let lowerCase = this.passwordLowerCase(password);
        let digits = this.passwordDigits(password);
        let nonAlpha = this.passwordNonAlpha(password);
        let whiteSpace = this.passwordWhiteSpace(password);

        // Length checks
        if (length < 6) {
            return 1;
        } else if (length < 16) {
            strengthScore += 10;
        } else {
            strengthScore += 15;
        }

        // Upper/Lowercase checks
        if (lowerCase) {
            strengthScore += 1;
        }
        if (upperCase) {
            strengthScore += 5;
        }

        if (upperCase && lowerCase) {
            strengthScore += 2;
        }

        // Number check
        if (digits && digits.length > 1) {
            strengthScore += 5;
        }

        // Non Alpha check
        if (nonAlpha) {
            strengthScore += (nonAlpha.length > 1) ? 15 : 10;
        }

        // All of the above check
        if (upperCase && lowerCase && digits && nonAlpha) {
            strengthScore += 15;
        }

        // Whitespace check
        if (whiteSpace) {
            strengthScore += 10;
        }

        // Tally em up and return the final strength value
        if (strengthScore < 20) {
            return 25;
        }

        if (strengthScore < 35) {
            return 50;
        }

        if (strengthScore < 50) {
            return 75;
        }

        return 100;
    }

    private passwordUpperCase(password) {
        return password.match(/[A-Z]/g);
    }

    private passwordLowerCase(password) {
        return password.match(/[a-z]/g);
    }

    private passwordDigits(password) {
        return password.match(/\d/g);
    }

    private passwordNonAlpha(password) {
        return password.match(/\W/g)
    }

    private passwordWhiteSpace(password) {
        return password.match(/\s/);
    }
}


// WEBPACK FOOTER //
// ./src/lib/components/form/password-strength/password-strength.service.ts